import React from 'react';
import ReactDOM from "react-dom";
import App from '@app/App';

function mount() {
  const container = document.getElementById("root");
  if (!container) return;
  ReactDOM.render(<App />, container);
}

(function bootstrap() {
  const started = Date.now();
  const waitSdk = setInterval(() => {
    // @ts-expect-error: BX24 — глобальный
    if (window.BX24 && typeof BX24.init === 'function') {
      clearInterval(waitSdk);
      try {
        BX24.init(() => {
          mount();
        });
        // страховка: если коллбек не пришёл — монтируем через 2с
        setTimeout(() => {
          const hasChildren = !!document.querySelector('#root > *');
          if (!hasChildren) mount();
        }, 2000);
      } catch (e) {
        console.warn('BX24.init error:', e);
        mount();
      }
    } else if (Date.now() - started > 8000) {
      clearInterval(waitSdk);
      console.warn('BX24 SDK not found — mounting anyway.');
      mount();
    }
  }, 100);
})();
